module.exports = "/ThumbsDown@2x-5f1cba47f1f3931d89ce435515a5fa79.png";